module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Regular.4dcd83f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/NotoSansCJKkr-Regular.woff2
// module id = UzBS
// module chunks = 0